import _ from 'lodash';

class Step {
  constructor(fields, order, label, validationRules, route, icon) {
    this.fields = fields;
    this.order = order;
    this.label = label;
    this.validationRules = validationRules;
    this.route = route;
    this.errorMessages = [];
    this.hidden = false;
    this.icon = icon;
  }

  hasContent(formData) {
    return _.some(this.fields, f =>
      formData[f] && formData[f].hasOwnProperty('length')
        ? formData[f].length
        : formData[f],
    );
  }

  validate(formData) {
    //run through validatiion rules here
    const errors = this.validationRules
      ? this.validationRules.map(rule => rule(formData))
      : [];
    this.errorMessages = _.compact(errors);
  }

  status(largestOrderVisited) {
    if (this.order >= largestOrderVisited) {
      return 0; //unvisited
    }
    if (this.errorMessages.length > 0) {
      return 1; //error
    } else {
      return 2; //valid
    }
  }

  setComponent(component) {
    this.component = component;
  }
}

export default [
  new Step(
    ['title', 'description', 'roomType'],
    1,
    'Description',
    [
      listing => (!listing.title ? 'Title is required' : null),
      listing =>
        listing.title && listing.title.length < 3
          ? 'Title must be at least 3 character long'
          : null,
      listing => (!listing.description ? 'Description is required' : null),
      listing =>
        listing.description && listing.description.length < 10
          ? 'Description must be at least 10 characters long'
          : null,
    ],
    'description',
    'fal fa-pen-nib',
  ),
  new Step(
    ['street', 'buildingname', 'city', 'state', 'zipcode'],
    2,
    'Address',
    [
      listing => (!listing.street ? 'Street address is required' : null),
      listing =>
        listing && listing.street && listing.street.indexOf('#') > -1
          ? 'Street addresses cannot contain # symbols. Place your suite or appartment number in the next address field.'
          : null,
      listing => (!listing.city ? 'City is required' : null),
      listing => (!listing.state ? 'State is required' : null),
      listing => (!listing.zipcode ? 'Zipcode is required' : null),
    ],
    'location',
    'fal fa-map-marker-alt',
  ),
  new Step(
    ['blockedDates'],
    3,
    'Availability',
    [],
    'calendar',
    'fal fa-calendar-times',
  ),
  new Step(
    ['dailyRate'],
    4,
    'Price',
    [listing => (!listing.dailyRate ? 'You must enter a listing price' : null)],
    'pricing',
    'fal fa-dollar-sign',
  ),
  new Step(
    ['listingRules'],
    5,
    'Rules',
    [],
    'house-rules',
    'fal fa-clipboard-check',
  ),
  new Step(
    ['listingPhotos'],
    6,
    'Photos',
    [
      listing => {
        return !listing.coverPhotoName ? 'At least 1 photo is required' : null;
      },
    ],
    'photos',
    'fal fa-images',
  ),
  new Step(['editing'], 7, 'Review', [], 'home', 'fal fa-check'),
];



// WEBPACK FOOTER //
// ./src/components_new/listing/ListingSteps.js